<template>
  <div class="main-bas">
    <div class="title-jibne">数字版权信息补录</div>
    <div class="nave-dd">
      <el-card shadow="never" class="card-aut-cc">
        <div class="navere-tit">
          <span>作品名称：</span> {{ queryDciInfo ? queryDciInfo.workName : workInfo.workName }}
        </div>
        <div class="navere-tit">
          <span> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; {{ type == 'REPLACE_DCI' ? '流水号:' : "DCI:" }}</span>
          {{ type == 'REPLACE_DCI' ? '' : workInfo.dciWorkId }}

          <el-input v-if="type == 'REPLACE_DCI'" v-model="replaceDci" class="el-inp-type"></el-input>
          <el-button v-if="type == 'REPLACE_DCI'" type="primary" @click="onSubmitInfo">查找</el-button>

        </div>
        <div class="navere-tit">
          <span>作者：</span> {{ workInfo.authorName }}
        </div>
        <div class="navere-tit fail-detail" v-if="form.failDetail">
          <span>补证失败原因：</span> {{ form.failDetail }}
        </div>
        <div class="navere-tit">
          <span>作品文件：</span>
          <el-button @click="downFile(queryDciInfo ? queryDciInfo.workFileIdLocal : workInfo.workFileIdLocal)"
            class="el-button-cfile" type="text">
            {{ queryDciInfo ? queryDciInfo.workFileIdLocal : workInfo.workFileIdLocal }}</el-button>
        </div>
      </el-card>

      <!-- <el-card shadow="never" class="card-aut-cc"> -->
      <el-form ref="formName" :model="form" :rules="rules">
        <el-card shadow="never" class="card-aut-cc">
          <div class="span-cc">* 创作目的:</div>

          <el-form-item prop="creationPurpose">
            <el-input v-model="form.creationPurpose" type="textarea" :autosize="{ minRows: 5, maxRows: 8 }"
              placeholder="不超过50字。例：作品的创作目的主要是测试。" :maxlength="50" show-word-limit></el-input>
          </el-form-item>
        </el-card>

        <el-card shadow="never" class="card-aut-cc">
          <div class="span-cc">* 创作过程:</div>

          <el-form-item prop="creationProcess">
            <el-input v-model="form.creationProcess" type="textarea" :autosize="{ minRows: 5, maxRows: 8 }"
              placeholder="不超过85字。例：由本人2023年7月在杭州市创作。" :maxlength="85" show-word-limit></el-input>
          </el-form-item>
        </el-card>

        <el-card shadow="never" class="card-aut-cc">
          <div class="span-cc">* 独创性说明:</div>

          <el-form-item label="独创性说明:" prop="originality">
            <el-input v-model="form.originality" type="textarea" :autosize="{ minRows: 5, maxRows: 8 }"
              placeholder="不超过126字。例：整个作品的创作主题和构思体现了作品的独创性。" :maxlength="126" show-word-limit></el-input>
          </el-form-item>
          <span class="info-ziy">请仔细认真填写独创性说明，需要从作者角度阐述独创性，本内容补正较多，一定要细心细心再细心</span>
        </el-card>

        <el-card shadow="never" class="card-aut-cc">
          <div class="span-cc">* 字体声明:</div>

          <el-form-item prop="originality">
            <el-select v-model="form.fontCopyright" placeholder="请选择字体类型" class="el-select-cc"
              @change="fontUploadChange">
              <el-option :label="item.label" :value="item.value" v-for="item in originalityType"
                :key="item.value"></el-option>
            </el-select>
            <span class="info-ziy">请确认作品中没有任何字体则选择此项，若有字体，请根据实际情况选择</span>
          </el-form-item>
        </el-card>

        <el-card shadow="never" class="card-aut-cc">
          <div class="span-cc">* 权利归属证明文件</div>
          <el-select v-model="certificateOwnership" placeholder="请选择字体类型" class="el-select-cc" disabled>
            <el-option :label="item.label" :value="item.value" v-for="item in certificateOwnershipOption"
              :key="item.value"></el-option>
          </el-select>
          <!-- 已上传文件 -->
          <div class="row-cc other-file-list" v-if="form.ownershipFileidsLocal">
            <div class="other-file-item">
              <el-button @click="downFile(form.ownershipFileidsLocal)" type="text" icon="el-icon-document">
                {{ form.ownershipFileidsLocal }}
              </el-button>
              <el-button type="danger" icon="el-icon-delete" circle size="mini" @click="() => {
                form.ownershipFileidsLocal = ''
                form.ownershipFileids = ''
                fileList1 = []
              }"></el-button>
            </div>
          </div>
          <div class="row-cc ssa-asef" v-if="certificateOwnership !== 'PERSON'">
            请上传{{
            getLabelByValue(certificateOwnership, certificateOwnershipOptioninfo)
          }}:
          </div>
          <el-form-item class="row-cc" v-if="certificateOwnership !== 'PERSON' && !form.ownershipFileidsLocal">
            <el-upload class="avatar-uploader" action="#" drag :limit="1" :before-remove="beforeRemove"
              :before-upload="beforeAvatarUpload" :auto-upload="false" :on-change="ownershipChange" :show-file-list="false"
              accept=".pdf">
              <i class="el-icon-upload"></i>
              <div class="el-upload__text">
                将文件拖到此处，或<em>点击上传</em>
              </div>
              <el-progress v-if="percentage1 != 0 && percentage1 != 100" :percentage="percentage1"></el-progress>
            </el-upload>
          </el-form-item>
        </el-card>

        <el-card shadow="never" class="card-aut-cc">
          <div class="span-cc">* 肖像权授权文件</div>
          <el-select v-model="fontCopyright2" placeholder="请选择是否涉及肖像权授权" class="el-select-cc">
            <el-option label="不涉及肖像权" value="1"></el-option>
            <el-option label="肖像权授权文件" value="2"></el-option>
          </el-select>
          <!-- 已上传文件 -->
          <div class="row-cc other-file-list" v-if="form.portraitAuthFileidLocal">
            <div class="other-file-item">
              <el-button @click="downFile(form.portraitAuthFileidLocal)" type="text" icon="el-icon-document">
                {{ form.portraitAuthFileidLocal }}
              </el-button>
              <el-button type="danger" icon="el-icon-delete" circle size="mini" @click="() => {
                form.portraitAuthFileidLocal = ''
                form.portraitAuthFileid = ''
                fileList2 = []
              }"></el-button>
            </div>
          </div>
          <el-form-item class="row-cc" v-if="fontCopyright2 === '2' && !form.portraitAuthFileidLocal">
            <el-upload class="avatar-uploader" action="#" :limit="1" drag
              :before-remove="beforeRemove" :before-upload="beforeAvatarUpload" :auto-upload="false"
              :on-change="portraitAuthChange" :show-file-list="false" accept=".pdf">
              <i class="el-icon-upload"></i>
              <div class="el-upload__text">
                将文件拖到此处，或<em>点击上传</em>
              </div>
              <el-progress v-if="percentage2 != 0 && percentage2 != 100" :percentage="percentage2"></el-progress>
            </el-upload>
          </el-form-item>
        </el-card>

        <el-card shadow="never" class="card-aut-cc">
          <div class="span-cc">* 他人作品授权文件</div>
          <el-select v-model="fontCopyright3" placeholder="请选择是否涉及他人作品授权文件" class="el-select-cc"
            :disabled="form.fontCopyright == 'AUTHORIZED_FONT'">
            <el-option label="不涉及他人作品" value="1"></el-option>
            <el-option label="他人作品授权文件" value="2"></el-option>
          </el-select>
          <!-- 已上传文件 -->
          <div class="row-cc other-file-list" v-if="form.othersWorkAuthFileidLocal">
            <div class="other-file-item">
              <el-button @click="downFile(form.othersWorkAuthFileidLocal)" type="text" icon="el-icon-document">
                {{ form.othersWorkAuthFileidLocal }}
              </el-button>
              <el-button type="danger" icon="el-icon-delete" circle size="mini" @click="() => {
                form.othersWorkAuthFileidLocal = ''
                form.othersWorkAuthFileid = ''
                fileList3 = []
              }"></el-button>
            </div>
          </div>
          <el-form-item class="row-cc" v-if="fontCopyright3 === '2' && !form.othersWorkAuthFileidLocal">
            <el-upload class="avatar-uploader" action="#" :limit="1" drag
              :before-remove="beforeRemove" :before-upload="beforeAvatarUpload" :auto-upload="false"
              :on-change="othersWorkChange" :show-file-list="false" accept=".pdf">
              <i class="el-icon-upload"></i>
              <div class="el-upload__text">
                将文件拖到此处，或<em>点击上传</em>
              </div>
              <el-progress v-if="percentage3 != 0 && percentage3 != 100" :percentage="percentage3"></el-progress>
            </el-upload>
          </el-form-item>
        </el-card>

        <el-card shadow="never" class="card-aut-cc">
          <div class="span-cc">其他证明文件 <span style="color: #909399; font-size: 12px; font-weight: normal;">（最多10个文件）</span></div>
          <!-- 已上传文件列表 -->
          <div class="row-cc other-file-list" v-if="form.otherFileIdListLocal.length > 0">
            <div class="other-file-item" v-for="(file, index) in form.otherFileIdListLocal" :key="index">
              <el-button @click="downFile(file)" type="text" icon="el-icon-document">
                文件{{ index + 1 }}：{{ otherFileNames[index] || file }}
              </el-button>
              <el-button class="el-button-cfile" type="danger" icon="el-icon-delete" circle size="mini" @click="removeOtherFile(index)"></el-button>
            </div>
          </div>
          <div class="row-cc info-ziy" v-if="certificateOwnership == 'EMPLOYMENT'">请上传职工《劳动合同》或《劳务合同》</div>

          <el-form-item class="row-cc" v-if="form.otherFileIdListLocal.length < 10">
            <el-upload class="avatar-uploader" action="#" drag :before-remove="beforeRemove"
              :before-upload="beforeAvatarUpload" :auto-upload="false" :on-change="otheryChange" :show-file-list="false"
              accept=".pdf">
              <i class="el-icon-upload"></i>
              <div class="el-upload__text">
                将文件拖到此处，或<em>点击上传</em>
              </div>
              <el-progress v-if="percentage4 != 0 && percentage4 != 100" :percentage="percentage4"></el-progress>
            </el-upload></el-form-item>
        </el-card>

        <!-- <el-card shadow="never" class="card-aut-cc">
          <div class="span-cc">* 发票信息:</div>
          <div class="never-cc">
            <el-form-item prop="invoiceType" label="发票类型">
              <el-select v-model="form.invoiceType" placeholder="请选择发票类型" class="el-select-cc" disabled>
                <el-option label="普票" value="NORMAL"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item prop="invoiceHeader" label="抬头">
              <el-input disabled v-model="form.invoiceHeader" placeholder="发票抬头,必须为著作权人之一"></el-input>
            </el-form-item>
            <el-form-item prop="taxpayerNumber" label="纳税人识别号">
              <el-input v-model="form.taxpayerNumber" placeholder="纳税人识别号 机构必填"></el-input>
            </el-form-item>
            <el-form-item prop="registeredAddress" label="地址">
              <el-input v-model="form.registeredAddress" placeholder="注册地址 专票必填"></el-input>
            </el-form-item>
            <el-form-item prop="openAccountTel" label="电话">
              <el-input v-model="form.openAccountTel" placeholder="开户电话 专票必填"></el-input>
            </el-form-item>
            <el-form-item prop="openAccountBank" label="开户银行">
              <el-input v-model="form.openAccountBank" placeholder="开户银行 专票必填"></el-input>
            </el-form-item>
            <el-form-item prop="bankAccount" label="银行账号">
              <el-input v-model="form.bankAccount" placeholder="银行账号,专票必填"></el-input>
            </el-form-item>

          
          </div>
        </el-card> -->

        <el-form-item>
          <el-row class="btn-cc">
            <el-button type="primary" @click="onSubmitUpdate">提交</el-button>
            <el-button @click="onSubmitfanhui">返回</el-button>
          </el-row></el-form-item>
      </el-form>
      <!-- </el-card> -->
    </div>

    <el-dialog title="预览" :visible.sync="dialogVisilock" width="80%">
      <file-preview class="btn-isooreview" :file-data="selectedFile" :file-type="fileType"
        style="width: 100%; height: 68vh"></file-preview>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="downCheck(dialogVisilockpath)">下载</el-button>
        <el-button @click="dialogVisilock = false">关闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import {
  upload,
  registrationSave,
  workInfo,
  registrationInfo,
  registrationUpdate,
  dciRegistration,
  retryDigitalRegister,
  getInfoByDciUserId,
  registrationList,
} from '@/api/user.js'

export default {
  name: '',
  components: {},
  mixins: [],
  props: {},
  data() {
    return {
      isupd: false, //是否是修改
      form: {
        // 11 A发票信息 银行账号 专票必填
        bankAccount: '',
        // 11 补充文件 内容梗概文件OSS Id,通过getUploadUrl接口上传文件获取，文件支持PDF、JPG、JPEG、PNG格式，大小不超过10M
        contentSummaryFileid: '',
        // 11 A补充文件 内容梗概文件OSS Id,通过getUploadUrl接口上传文件获取，文件支持PDF、JPG、JPEG、PNG格式，大小不超过10M
        contentSummaryFileidLocal: '',
        // 11 作品创作说明 创作过程,长度不超过85字
        creationProcess: '',
        // 11 作品创作说明 创作目的,长度不超过50字
        creationPurpose: '',
        // A表示DCI申领作品的标识，通过DCI申领接口获得
        dciContentId: '',

        // 11 A作品创作说明 字体声明NO_NEED不涉及字体版权FREE_FONT公共免费字体ORIGINAL_FONT原创字体AUTHORIZED_FONT商用字体已授权OPEN_SOURCE_FONT开源字体
        fontCopyright: 'NO_NEED',

        // 11 A发票信息 发票抬头，必须为著作权人之一
        invoiceHeader: '',

        // 11 A发票信息 发票类型NORMAL普票SPECIAL专票
        invoiceType: 'NORMAL',

        // 11 发票信息 开户银行 专票必填
        openAccountBank: '',

        // 11 发票信息 开户电话 专票必填
        openAccountTel: '',
        // 11 作品创作说明 独创性说明,长度不超过140字
        originality: '',
        // 11 后台好像少这个
        otherFileIdList: [],

        // 11 补充文件 其他文件列表，其他文件OSS Id,通过getUploadUrl接口上传文件获取，文件支持PDF、JPG、JPEG、PNG格式，大小不超过10M，列表个数不超过10个
        otherFileIdListLocal: [],
        // 11 补充文件 他人作品授权文件OSS Id,通过getUploadUrl接口上传文件获取。文件支持PDF、JPG、JPEG、PNG格式，大小不超过10M
        othersWorkAuthFileid: '',
        // 11 补充文件 他人作品授权文件OSS Id,通过getUploadUrl接口上传文件获取。文件支持PDF、JPG、JPEG、PNG格式，大小不超过10M
        othersWorkAuthFileidLocal: '',
        // 11 补充文件 权利归属证明文件OSS Id,通过getUploadUrl接口上传文件获取。当申请的作品是法人作品时,DCI的申请人为企业用户
        ownershipFileids: '',
        // 11 补充文件 权利归属证明文件OSS Id,通过getUploadUrl接口上传文件获取。当申请的作品是法人作品时,DCI的申请人为企业用户
        ownershipFileidsLocal: '',
        // 11 补充文件 肖像权授权文件OSS
        portraitAuthFileid: '',
        // 11 补充文件 肖像权授权文件OSS I
        portraitAuthFileidLocal: '',
        // 11发票信息 注册地址 专票必填
        registeredAddress: '',
        // 11 发票信息 注册电话 专票必填填
        registeredTel: '',
        // 11 发票信息 纳税人识别号 机构必填
        taxpayerNumber: ''
      },

      rules: {
        creationPurpose: [
          { required: true, message: '请输入填写内容', trigger: 'blur' }
        ],
        creationProcess: [
          { required: true, message: '请输入填写内容', trigger: 'blur' }
        ],
        originality: [
          { required: true, message: '请输入填写内容', trigger: 'blur' }
        ],
        originality: [
          { required: true, message: '请输入填写内容', trigger: 'blur' }
        ]
      },

      originalityType: [
        { value: 'NO_NEED', label: '不涉及字体版权' },
        { value: 'FREE_FONT', label: '公共免费字体' },
        { value: 'ORIGINAL_FONT', label: '原创字体' },
        { value: 'AUTHORIZED_FONT', label: '商用字体已授权' },
        { value: 'OPEN_SOURCE_FONT', label: '开源字体' }
      ],
      // 权利归属证明文件OSS
      ownershipFileid: '',
      // 肖像权授权文件OSS
      portraitAuthFileid: '',
      // 他人作品授权文件OSS
      othersWorkAuthFileid: '',
      // 内容梗概文件OSS
      contentSummaryFileid: '',
      // 其他文件OSS
      otherFileIdList: '',
      // 字体文件
      fontCopyrightFileid: '',
      workInfo: {},
      fontCopyright2: '1',
      fontCopyright3: '1',
      certificateOwnership: 'PERSON',
      certificateOwnershipOption: [
        { value: 'PERSON', label: '个人作品' },
        { value: 'ENTERPRISE', label: '法人作品' },
        { value: 'EMPLOYMENT', label: '职务作品' },
        { value: 'COMISSION', label: '委托作品' }
      ],
      certificateOwnershipOptioninfo: [
        { value: 'PERSON', label: '个人作品' },
        { value: 'ENTERPRISE', label: '法人创作说明' },
        { value: 'EMPLOYMENT', label: '职务创作声明' },
        { value: 'COMISSION', label: '委托创作协议' }
      ],
      percentage1: 0,
      percentage2: 0,
      percentage3: 0,
      percentage4: 0,
      //
      fileList1: [],
      fileList2: [],
      fileList3: [],
      fileList4: [],
      otherFileNames: [], // 存储其他证明文件的原始文件名
      type: '', //TOBE_AMEND 补正状态
      dialogVisilock: false,
      dialogVisilockpath: '',
      selectedFile: '',
      fileType: '',
      replaceDci: '',
      queryDciInfo: '',
      replaceDciContid: '',
    }
  },
  computed: {
    // 计算属性绑定到Vuex store中的userInfo
    userInfo() {
      return this.$store.state.userInfo.user
    },
    // 计算属性绑定到Vuex store中的userInfo
    realInformation() {
      return this.$store.state.realInformation
    },
    isPersonal() {
      return this.realInformation.legalPersonCertName ? false : true
    }
  },
  watch: {},
  async created() {
    this.type = this.$route.query.type

    if (this.$route.query.dciWorkId) {
      this.active = 1
      this.dciWorkId = this.$route.query.dciWorkId

      const res = await workInfo({
        dciWorkId: this.dciWorkId
      })

      if (res && res.code == 200) {
        this.workInfo = res.data
        this.certificateOwnership = res.data.ownershipWay
      }
      const res2 = await registrationInfo({
        contentId: this.$route.query.dciContentId
      })
      if (res2 && res2.code == 200) {
        if (res2.data) {
          this.isupd = true
          this.form = { ...res2.data }
        }
      }
    }

    this.form.invoiceType = 'NORMAL'
    this.form.invoiceHeader = this.workInfo.authorName
    getInfoByDciUserId({
      dciUserId: this.workInfo.dciUserId
    }).then(res => {
      if (res && res.code == 200 && res.data.legalPersonCertName) {
        this.form.taxpayerNumber = res.data.certificateNumber
      }
    })

    if (this.type == 'REPLACE_DCI') {
      this.replaceDci = this.$route.query.dciWorkId
      this.replaceDciContid = this.$route.query.dciContentId
    }
  },
  async mounted() { },
  methods: {
    async onSubmitInfo() {
      const res = await workInfo({
        dciWorkId: this.replaceDci
      })

      if (res && res.code == 200) {
        if (res.data.dciWorkStatus != 'DCI_PRE_REG_FINISH') {
          this.$message.error('请等待该作品完成登记后再查询。')
          return
        }

        const newCopyrightOwnerIds = res.data.copyrightOwnerIds || [];
        const oldCopyrightOwnerIds = this.workInfo.copyrightOwnerIds || [];
        if (!oldCopyrightOwnerIds.some(item => newCopyrightOwnerIds.includes(item))) {
          this.$message.error('仅允许同著作权人的作品进行修改替换。')
          return
        }

        let cont = await this.search()
        if (cont) {
          this.$message.error('该作品已申请数登，请勿重复登记。')
          return

        }
        this.$message.success('替换DCI校验成功，可以进行提交。')

        this.queryDciInfo = res.data

      }
    },
    async search() {
      const res = await registrationList(
        {
          digitalRegisterStatus: '',
          searchValue: this.replaceDci,
          params: {
            beginTime: '',
            endTime: '',
            applyType: '',
            status: 'total'
          }
        },
        {
          pageNum: 1,
          pageSize: 10,
          tableName: undefined,
          tableComment: undefined,
          isAsc: 'desc',
          orderByColumn: 'dr.create_time'
        }
      )
      console.log(res, 'res')
      if (res.code == 200) {
        console.log(res.rows[0].digitalRegisterStatus, 'zzzzzzzzzzz');
        if (res.rows[0].digitalRegisterStatus == 'NO_APPLY') {
          this.replaceDciContid = res.rows[0].dciContentId
          return false
        } else {
          return true
        }

      } else {
        this.$message.error('查询失败' + res.msg)
      }

      return true
    },
    getLabelByValue(value, works) {
      const found = works.find(work => work.value === value)
      return found ? found.label : value
    },
    async onSubmitUpdate() {
      this.$refs.formName.validate(async valid => {
        if (valid) {
          this.form.dciContentId = this.$route.query.dciContentId

          // 开户电话与注册电话电话一致填一个
          this.form.registeredTel = this.form.openAccountTel
          let res = ''

          if (this.isupd) {
            let dciContentIdNew = {}
            if (this.type == 'REPLACE_DCI') {
              // 相同不传
              if (this.$route.query.dciContentId != this.replaceDciContid) {
                dciContentIdNew.dciContentIdNew = this.replaceDciContid
              }
            }
            res = await registrationUpdate({ ...this.form, ...dciContentIdNew })
          } else {
            // 根据字体声明选在独创性说明末尾自动添加以下字符 只有新增时才需要添加
            // 不涉及字体版权：不填充
            // 公共免费字体：作品中涉及字体为公共免费字体
            // 原创字体：作品中涉及字体为原创字体
            // 商用字体已授权：作品中涉及字体为商用授权字体
            // 开源字体：作品中涉及字体为开源字体
            if (this.form.fontCopyright == 'FREE_FONT') {
              this.form.originality += '作品中涉及字体为公共免费字体'
            } else if (this.form.fontCopyright == 'ORIGINAL_FONT') {
              this.form.originality += '作品中涉及字体为原创字体'
            } else if (this.form.fontCopyright == 'AUTHORIZED_FONT') {
              this.form.originality += '作品中涉及字体为商用授权字体'
            } else if (this.form.fontCopyright == 'OPEN_SOURCE_FONT') {
              this.form.originality += '作品中涉及字体为开源字体'
            }
            res = await registrationSave(this.form)
          }

          if (res.code == 200) {
            this.$message.success('数字登记保存成功')

            if (this.type == 'TOBE_AMEND' || this.type == 'REPLACE_DCI') {
              let dciContentId = this.$route.query.dciContentId
              if (this.type == 'REPLACE_DCI') {
                dciContentId = this.replaceDciContid
              }
              // 补证接口
              const resRegister = await retryDigitalRegister({
                dciContentId: dciContentId
              })
              if (resRegister && resRegister.code == 200) {
                this.$message.success('数字登记补证成功')
                this.$router.push({
                  path: '/DigitalCopyrightRegistration'
                })
              }
            } else {
              const res2 = await dciRegistration({
                contentId: this.$route.query.dciContentId
              })

              if (res2.code == 200) {
                this.$message.success('数字登记上传成功')
                this.$router.push({
                  path: '/DigitalCopyrightRegistration'
                })
              } else {
                this.$message.error('数字登记上传失败' + res.msg)
                return false
              }
            }
          } else {
            this.$message.error('数字登记保存失败' + res.msg)
            return false
          }
        } else {
          this.$message.error('请填写完整信息')
          return false
        }
      })
    },
    onSubmitfanhui() {
      this.$router.push({
        path: '/DigitalCopyrightRegistration'
      })
    },
    async ownershipChange(file) {
      if (file.size > 1024 * 1024 * 200) {
        this.$message.error('文件最大支持200M')
        this.fileList1 = []
        return false
      }
      this.ownershipFileid = file.raw

      let FrontFileId = new FormData()
      FrontFileId.append('file', this.ownershipFileid)
      const resFront = await upload(FrontFileId, progressEvent => {
        // 计算上传进度百分比
        const percentCompleted = Math.round(
          (progressEvent.loaded * 100) / progressEvent.total
        )
        console.log(percentCompleted, 'percentCompleted')

        this.percentage1 = percentCompleted == 100 ? 98 : percentCompleted
      })
      if (resFront.code == 200) {
        this.percentage1 = 100
        this.form.ownershipFileids = resFront.dciFile
        this.form.ownershipFileidsLocal = resFront.ossFile
        this.$message.success('上传成功')
      } else {
        this.$message.error(resFront.msg)
        return false
      }
    },
    async portraitAuthChange(file) {
      if (file.size > 1024 * 1024 * 200) {
        this.$message.error('文件最大支持200M')
        this.fileList2 = []
        return false
      }
      this.portraitAuthFileid = file.raw
      let FrontFileId = new FormData()
      FrontFileId.append('file', this.portraitAuthFileid)
      const resFront = await upload(FrontFileId, progressEvent => {
        // 计算上传进度百分比
        const percentCompleted = Math.round(
          (progressEvent.loaded * 100) / progressEvent.total
        )
        console.log(percentCompleted, 'percentCompleted')

        this.percentage2 = percentCompleted == 100 ? 98 : percentCompleted
      })
      if (resFront.code == 200) {
        this.percentage2 = 100
        this.form.portraitAuthFileid = resFront.dciFile
        this.form.portraitAuthFileidLocal = resFront.ossFile
        this.$message.success('上传成功')
      } else {
        this.$message.error(resFront.msg)
        return false
      }
    },
    async othersWorkChange(file) {
      if (file.size > 1024 * 1024 * 200) {
        this.$message.error('文件最大支持200M')
        this.fileList3 = []
        return false
      }
      this.othersWorkAuthFileid = file.raw
      let FrontFileId = new FormData()
      FrontFileId.append('file', this.othersWorkAuthFileid)
      const resFront = await upload(FrontFileId, progressEvent => {
        // 计算上传进度百分比
        const percentCompleted = Math.round(
          (progressEvent.loaded * 100) / progressEvent.total
        )
        console.log(percentCompleted, 'percentCompleted')

        this.percentage3 = percentCompleted == 100 ? 98 : percentCompleted
      })
      if (resFront.code == 200) {
        this.percentage3 = 100
        this.form.othersWorkAuthFileid = resFront.dciFile
        this.form.othersWorkAuthFileidLocal = resFront.ossFile
        this.$message.success('上传成功')
      } else {
        this.$message.error(resFront.msg)
        return false
      }
    },
    async otheryChange(file) {
      // 检查是否已达上限
      if (this.form.otherFileIdListLocal.length >= 10) {
        this.$message.warning('最多上传10个文件')
        return false
      }
      if (file.size > 1024 * 1024 * 200) {
        this.$message.error('文件最大支持200M')
        return false
      }
      this.otherFileIdList = file.raw
      let FrontFileId = new FormData()
      FrontFileId.append('file', this.otherFileIdList)
      const resFront = await upload(FrontFileId, progressEvent => {
        // 计算上传进度百分比
        const percentCompleted = Math.round(
          (progressEvent.loaded * 100) / progressEvent.total
        )
        console.log(percentCompleted, 'percentCompleted')

        this.percentage4 = percentCompleted == 100 ? 98 : percentCompleted
      })
      if (resFront.code == 200) {
        this.percentage4 = 100
        // 追加到数组，支持多文件
        this.form.otherFileIdList.push(resFront.dciFile)
        this.form.otherFileIdListLocal.push(resFront.ossFile)
        this.otherFileNames.push(file.name) // 保存原始文件名
        this.$message.success('上传成功')
        // 重置进度条
        setTimeout(() => {
          this.percentage4 = 0
        }, 300)
      }
    },
    // 删除单个其他证明文件
    removeOtherFile(index) {
      this.form.otherFileIdList.splice(index, 1)
      this.form.otherFileIdListLocal.splice(index, 1)
      this.otherFileNames.splice(index, 1) // 同步删除文件名
    },
    fontUploadChange(val) {
      console.log(val)
      if (val == 'AUTHORIZED_FONT') {
        this.fontCopyright3 = '2'
      } else {
        this.fontCopyright3 = ''
      }
    },

    beforeRemove(file, fileList) {
      this.percentage1 = 0
      this.percentage2 = 0
      this.percentage3 = 0
      this.percentage4 = 0
    },
    beforeAvatarUpload(file) {
      //   const isJPG = file.type === "image/jpeg";
      //   const isLt2M = file.size / 1024 / 1024 < 2;

      //   if (!isJPG) {
      //     this.$message.error("上传头像图片只能是 JPG 格式!");
      //   }
      //   if (!isLt2M) {
      //     this.$message.error("上传头像图片大小不能超过 2MB!");
      //   }
      //   return isJPG && isLt2M;
      return true
    },
    async downFile(path) {
      this.dialogVisilock = true
      this.dialogVisilockpath = path
      const resUrl = await this.$download.file(path)
      this.selectedFile = resUrl
      this.fileType = path.split('/')[0]
    },
    downCheck(path) {
      const parts = path.split('/')
      this.$download.name(path, parts[1] + '.' + parts[0])
    }
  }
}
</script>
<style lang="scss" scoped>
.title-jibne {
  letter-spacing: normal;
  color: #333333;
  line-height: normal;
  text-align: left;
  font-family: 'Arial Negreta', 'Arial Normal', 'Arial', sans-serif;
  font-weight: 700;
  font-style: normal;
  font-size: 19.9988px;
  white-space: nowrap;
  text-transform: none;
  text-rendering: optimizeLegibility;
  -webkit-font-feature-settings: 'kern';
  font-kerning: normal;
}

.stepscc {
  margin: 30px auto;
  width: 1200px;
}

.unslider {
  margin: 0 auto;
  width: 1200px;
  height: 865.9987px;
  display: flex;
  justify-content: space-around;
  align-items: center;

  >div {
    width: 469.9988px;
    height: 379.9988px;
    border-style: solid;
    border-color: rgba(121, 121, 121, 1);
    border-radius: 10.0012px;
    border-width: 1.0012px;
    text-align: center;
    display: flex;

    &:hover {
      cursor: pointer;
    }

    flex-direction: column;
    justify-content: center;

    > :nth-child(1) {
      font-size: 160.0012px;
    }

    > :nth-child(2) {
      margin: 19.9988px;
      letter-spacing: normal;
      color: #333333;
      line-height: normal;
      font-size: 24px;
      font-family: 'Arial Negreta', 'Arial Normal', 'Arial', sans-serif;
      font-weight: 700;
      font-style: normal;
      white-space: nowrap;
      text-transform: none;
      text-rendering: optimizeLegibility;
      -webkit-font-feature-settings: 'kern';
      font-kerning: normal;
    }
  }
}

.ssa-asef {
  font-size: 14px;
}

.nave-dd {
  background-color: #f2f2f2;
  padding: 10px 20px 10px 20px;
}

.form-aut {
  width: 799.9988px;
  margin-top: 49.9987px;
}

.el-select-cc {
  width: 499.9987px;
}

.card-aut-cc {
  margin-top: 10px;
}

.row-cc {
  margin-top: 10px;
}

.span-cc {
  letter-spacing: normal;
  color: #333333;
  line-height: normal;
  font-size: 18px;
  text-align: left;
  font-family: 'Arial Negreta', 'Arial Normal', 'Arial', sans-serif;
  font-weight: 700;
  font-style: normal;
  word-wrap: break-word;
  text-transform: none;
  text-rendering: optimizeLegibility;
  -webkit-font-feature-settings: 'kern';
  font-kerning: normal;
  margin-bottom: 10px;
}

.avatar-uploader {
  width: 370px;
}

.never-cc {
  width: 528px;
}

.navere-tit {
  margin-top: 10px;

  >span {
    letter-spacing: normal;
    color: #333333;
    line-height: normal;
    font-size: 16px;
    text-align: left;
    font-family: 'Arial Negreta', 'Arial Normal', 'Arial', sans-serif;
    font-weight: 700;
    font-style: normal;
    white-space: nowrap;
    text-transform: none;
    text-rendering: optimizeLegibility;
    -webkit-font-feature-settings: 'kern';
    font-kerning: normal;
  }

  font-size: 14px;
}

.btn-cc {
  margin-top: 10px;
  text-align: center;
}

.el-button-cfile {
  margin-left: 10px;
}

.other-file-list {
  flex-direction: column;
  align-items: flex-start;
}

.other-file-item {
  display: flex;
  align-items: center;
  width: 100%;
  padding: 6px 12px;
  margin-bottom: 6px;
  background: #f5f7fa;
  border-radius: 4px;
  border: 1px solid #e4e7ed;
}

.other-file-item .el-button--text {
  flex: 1;
  text-align: left;
  padding: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.other-file-item .el-button-cfile {
  flex-shrink: 0;
}

.fail-detail {
  color: red;
}

.info-ziy {
  padding-left: 10px;
  color: red;
  font-size: 18px;
  font-weight: 700;
}

.el-inp-type {
  width: 230px;
  margin-right: 15px;
}
</style>
